import clsx from 'clsx';
import type { ComponentPropsWithoutRef, FC } from 'react';

type ColorType = 'blue' | 'white' | 'red' | 'outlineRed';

type Props = {
  text?: string;
  colorType?: ColorType;
  height?: number;
  icon?: string;
  iconSize?: number;
  fontSize?: string;
  link?: string;
  targetBlank?: boolean;
} & ComponentPropsWithoutRef<'button'>;

export const BlockButton: FC<Props> = ({
  text = '',
  colorType = 'blue',
  height = 42,
  iconSize = 16,
  icon = '',
  fontSize = 'text-sm',
  targetBlank = false,
  ...props
}) => {
  const commonProps = {
    className: clsx(
      'flex w-full items-center justify-center rounded',
      colorType === 'blue' && 'bg-primary',
      colorType === 'white' && 'border border-solid border-border bg-white',
      colorType === 'red' && 'bg-red-700',
      colorType === 'outlineRed' && 'border border-solid border-danger bg-white text-danger',
      props.disabled ? 'cursor-not-allowed opacity-50' : 'hover:opacity-50',
      fontSize === 'text-sm' ? 'gap-2' : 'gap-1'
    ),
    style: { height: height },
  };

  const children = (
    <>
      {icon !== '' && <img src={icon} height={iconSize} width={iconSize} alt="" />}
      {text !== '' && (
        <span
          className={clsx(
            `${fontSize} font-bold`,
            colorType === 'blue' && 'text-white',
            colorType === 'red' && 'text-white'
          )}
        >
          {text}
        </span>
      )}
    </>
  );

  return props.link ? (
    <a
      href={props.link}
      {...(targetBlank ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      {...commonProps}
    >
      {children}
    </a>
  ) : (
    <button {...props} {...commonProps}>
      {children}
    </button>
  );
};
